var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuMpActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17V7H3.82464L7.90141 13.5286H6.41629L10.3766 7H13.2012L13.2303 17H10.0999L10.0708 11.6285H10.5658L7.85767 16.1H6.34344L3.5188 11.6285H4.13031V17H1ZM14.4487 17V7H19.3554C20.3067 7 21.1293 7.1524 21.8233 7.45714C22.5173 7.76193 23.0536 8.19758 23.4322 8.7643C23.8108 9.33097 24 10 24 10.7714C24 11.5429 23.8108 12.2095 23.4322 12.7714C23.0536 13.3333 22.5173 13.769 21.8233 14.0786C21.1293 14.3881 20.3067 14.5428 19.3554 14.5428H16.3561L17.8849 13.1V17H14.4487ZM17.8849 13.4715L16.3561 11.9429H19.137C19.6126 11.9429 19.9645 11.8381 20.1926 11.6286C20.4207 11.4191 20.5347 11.1334 20.5347 10.7715C20.5347 10.4096 20.4206 10.1239 20.1926 9.91435C19.9645 9.70483 19.6126 9.60007 19.137 9.60007H16.3561L17.8849 8.07149V13.4715Z",
    fill: "#0483F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMpActive);
export default __webpack_public_path__ + "static/media/menu-mp-active.e9a7d5df5ceb579550ed165b9622831b.svg";
export { ForwardRef as ReactComponent };